import { render, staticRenderFns } from "./Moderators.vue?vue&type=template&id=cb421f76"
import script from "./Moderators.vue?vue&type=script&lang=js"
export * from "./Moderators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports